import {
  ApolloClient,
  InMemoryCache,
  makeVar,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { LOCALSTORAGE_TOKEN } from "./contants";

const token = localStorage.getItem(LOCALSTORAGE_TOKEN);

export const isLoggedInVar = makeVar(Boolean(token));
export const authTokenVar = makeVar(token);
export const godModeVar = makeVar(false);
export const adminTokenVar = makeVar("");

export const url = "https://scalance-tesseract-ebcc510e34b9.herokuapp.com";
export const uri = url + "/graphql";

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      "x-jwt": authTokenVar() || null,
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),

  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          users: {
            // Don't cache separate results based on
            // any of this field's arguments.
            keyArgs: ["where", ["search", "role", "roles"]],
            // Concatenate the incoming list items with
            // the existing list items.
            merge(existing = {}, incoming, { args }): any {
              return {
                ...incoming,
                results: [...(existing.results || []), ...incoming.results],
              };
            },
          },
          shops: {
            keyArgs: ["where", "search"],
            merge(existing = { results: [] }, incoming) {
              // Combine existing and incoming results
              const combinedResults = [
                ...existing.results,
                ...incoming.results,
              ];

              // Deduplicate results using Set and JSON.stringify
              const mergedResults = Array.from(
                // @ts-ignore
                new Set(combinedResults.map(JSON.stringify))
                // @ts-ignore
              ).map(JSON.parse);

              return {
                ...incoming,
                results: mergedResults,
              };
            },
          },

          isLoggedIn: {
            read() {
              return isLoggedInVar();
            },
          },

          token: {
            read() {
              return authTokenVar();
            },
          },

          godMode: {
            read() {
              return godModeVar();
            },
          },
        },
      },
    },
  }),
});

//  "search",
//                 "createdAt",
//                 "siteId",
//                 "orderByCreatedAt",
//                 "orderByPrice",
//                 "orderByQuantity",
//                 "orderByCa",

//                 "productId",

//                 "price",
//                 "priceVariation",
//                 "orderByPriceVariation",

//                 "quantity",
//                 "quantityVariation",
//                 "orderByQuantityVariation",

//                 "start",
//                 "end",
